<template>
  <!-- Ornamento superior -->
  <div class="nav-ornament-wrapper">
    <img
      :src="require('@/assets/images/logos/rodasep-adorno-hd-transp-mod.webp')"
      alt="Adorno Rodasep"
      class="ornament-img"
    />
  </div>

  <!-- Menú móvil -->
  <div
    class="d-md-none d-flex justify-content-between align-items-center px-3 py-2"
  >
    <img
      :src="require('@/assets/images/logos/logo-2-hd-transp.webp')"
      alt="Logo Rodasep"
      class="logo-mobile"
    />
    <button class="btn btn-outline-dark" @click="toggleMenu">☰</button>
  </div>

  <!-- Panel lateral móvil -->
  <div class="mobile-nav" :class="{ open: isMenuOpen }">
    <div
      class="d-flex justify-content-between align-items-center p-3 border-bottom"
    >
      <span class="fw-bold">Menú Rodasep</span>
      <button class="btn-close" @click="toggleMenu"></button>
    </div>
    <ul class="list-unstyled px-3 pt-3">
      <li>
        <router-link to="/" class="nav-link" @click="closeMenu"
          >Inicio</router-link
        >
      </li>
      <li>
        <router-link to="/productos" class="nav-link" @click="closeMenu"
          >Productos</router-link
        >
      </li>

      <!-- Dropdown: Rodamientos -->
      <li
        class="nav-link"
        @click="toggleRodamientosDropdown"
        style="cursor: pointer"
      >
        Rodamientos
        <span class="ms-1">{{ isRodamientosOpen ? "▲" : "▼" }}</span>
      </li>
      <transition name="fade">
        <div v-if="isRodamientosOpen">
          <li class="ms-3">
            <router-link to="/agricola" class="nav-link" @click="closeMenu"
              >Agrícola</router-link
            >
          </li>
          <li class="ms-3">
            <router-link to="/automotriz" class="nav-link" @click="closeMenu"
              >Automotriz</router-link
            >
          </li>
          <li class="ms-3">
            <router-link to="/industrial" class="nav-link" @click="closeMenu"
              >Industrial</router-link
            >
          </li>
        </div>
      </transition>

      <!-- Dropdown: Locales -->
      <li
        class="nav-link mt-2"
        @click="toggleLocalesDropdown"
        style="cursor: pointer"
      >
        Locales <span class="ms-1">{{ isLocalesOpen ? "▲" : "▼" }}</span>
      </li>
      <transition name="fade">
        <div v-if="isLocalesOpen">
          <li class="ms-3">
            <router-link to="/talca" class="nav-link" @click="closeMenu"
              >Talca</router-link
            >
          </li>
          <li class="ms-3">
            <router-link to="/curico" class="nav-link" @click="closeMenu"
              >Curicó</router-link
            >
          </li>
          <li class="ms-3">
            <router-link to="/linares" class="nav-link" @click="closeMenu"
              >Linares</router-link
            >
          </li>
        </div>
      </transition>

      <li class="mt-3">
        <router-link to="/contactos" class="nav-link" @click="closeMenu"
          >Contáctanos</router-link
        >
      </li>
      <li>
        <router-link to="/nosotros" class="nav-link" @click="closeMenu"
          >Sobre Nosotros</router-link
        >
      </li>
    </ul>
  </div>

  <!-- Navbar escritorio -->
  <header class="header d-none d-md-flex align-items-center">
    <div
      class="container-fluid d-flex justify-content-between align-items-center py-2"
    >
      <!-- Logo -->
      <a href="#" class="d-flex align-items-center text-decoration-none">
        <img
          :src="require('@/assets/images/logos/logo-2-hd-transp.webp')"
          alt="Logo Rodasep"
          class="logo me-2"
        />
      </a>

      <!-- Menú horizontal -->
      <nav class="navmenu primary-navigation">
        <ul>
          <li>
            <router-link
              to="/"
              class="nav-link text-dark hvr-underline-from-left"
              >Inicio</router-link
            >
          </li>
          <li>
            <router-link
              to="/productos"
              class="nav-link text-dark hvr-underline-from-left"
              >Productos</router-link
            >
          </li>

          <!-- Dropdown Rodamientos -->
          <li class="nav-item dropdown">
            <span
              class="nav-link text-dark dropdown-toggle hvr-underline-from-left"
              >Rodamientos</span
            >
            <ul class="dropdown-menu">
              <li>
                <router-link to="/agricola" class="text-dark"
                  >Agrícola</router-link
                >
              </li>
              <li>
                <router-link to="/automotriz" class="text-dark"
                  >Automotriz</router-link
                >
              </li>
              <li>
                <router-link to="/industrial" class="text-dark"
                  >Industrial</router-link
                >
              </li>
            </ul>
          </li>

          <!-- Dropdown Locales -->
          <li class="nav-item dropdown">
            <span
              class="nav-link text-dark dropdown-toggle hvr-underline-from-left"
              >Locales</span
            >
            <ul class="dropdown-menu">
              <li>
                <router-link to="/talca" class="text-dark">Talca</router-link>
              </li>
              <li>
                <router-link to="/curico" class="text-dark">Curicó</router-link>
              </li>
              <li>
                <router-link to="/linares" class="text-dark"
                  >Linares</router-link
                >
              </li>
            </ul>
          </li>

          <li>
            <router-link
              to="/contactos"
              class="nav-link text-dark hvr-underline-from-left"
              >Contáctanos</router-link
            >
          </li>
          <li>
            <router-link
              to="/nosotros"
              class="nav-link text-dark hvr-underline-from-left"
              >Sobre Nosotros</router-link
            >
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      isMenuOpen: false,
      isLocalesOpen: false,
      isRodamientosOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflowX = this.isMenuOpen ? "hidden" : "";
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.isLocalesOpen = false;
      this.isRodamientosOpen = false;
      document.body.style.overflowX = "";
    },
    toggleLocalesDropdown() {
      this.isLocalesOpen = !this.isLocalesOpen;
    },
    toggleRodamientosDropdown() {
      this.isRodamientosOpen = !this.isRodamientosOpen;
    },
  },
};
</script>

<style scoped>
/* Estilos existentes (sin cambios) */
.logo {
  width: 200px;
  margin-left: 2.5rem;
  height: auto;
}
.logo-mobile {
  width: 160px;
  height: auto;
}
.header {
  background-color: #ffffff;
  position: relative;
  z-index: 2000;
  margin-top: 0;
  border-bottom: none !important;
  box-shadow: none !important;
}
.header + * {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.nav-ornament-wrapper {
  position: relative;
  width: 100%;
  height: 68px;
  overflow: hidden;
  z-index: 0;
}
.ornament-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.nav-ornament-wrapper::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    -45deg,
    rgba(0, 169, 224, 0.2) 40%,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(0, 169, 224, 0.2) 60%
  );
  background-size: 300%;
  background-position-x: 100%;
  animation: shimmer 5s infinite linear;
  mask-image: url("~@/assets/images/logos/rodasep-adorno-hd-transp-mod.webp");
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: cover;
  mask-mode: alpha;
  -webkit-mask-image: url("~@/assets/images/logos/rodasep-adorno-hd-transp-mod.webp");
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: cover;
  -webkit-mask-mode: alpha;
  pointer-events: none;
  z-index: 1;
}
@keyframes shimmer {
  to {
    background-position-x: 0%;
  }
}
.mobile-nav {
  position: fixed;
  top: 0;
  left: -100%;
  width: 80%;
  max-width: 320px;
  height: 100vh;
  background-color: white;
  z-index: 3000;
  transition: left 0.3s ease;
  overflow-y: auto;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.2);
}
.mobile-nav.open {
  left: 0;
}
.mobile-nav .nav-link {
  display: block;
  padding: 10px 0;
  color: #222;
  font-weight: 500;
}
.mobile-nav .nav-link:hover {
  color: #007bff;
  text-decoration: none;
}
body {
  overflow-x: hidden !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

/*Css responsivo para el adorno del navbar*/

@media (max-width: 768px) {
  .nav-ornament-wrapper {
    height: 20px; /* MÁS ALTO solo en mobile */
  }

  .nav-ornament-wrapper::before {
    /* Reaplicamos el brillo pero MUY sutil y más preciso */
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0.05) 100%
    );
    background-size: 300%;
    background-position-x: 100%;
    animation: shimmer 5s infinite linear;

    mask-image: url("~@/assets/images/logos/rodasep-adorno-hd-transp-mod.webp");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: cover;

    -webkit-mask-image: url("~@/assets/images/logos/rodasep-adorno-hd-transp-mod.webp");
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: cover;

    pointer-events: none;
    z-index: 1;
  }
}
</style>

<style src="@/assets/css/hover_effects/dropdown/navbar-dropdown.css"></style>
